<template>
    <div class="headContent">
        <div class="headTopBox">
            <div class="align">
                <div class="logoBox align" @click="logoTap">
                    <el-image v-if="headData.logo" :src="headData.logo" fit="cover" class="logo"></el-image>
                    <div class="appName">{{ headData.name }}</div>
                </div>
                 <div class="headTopNavList align">
                    <div :class="['headTopNav',active == index && !isMy ? 'headTopNavOn' : '']" v-for="(item,index) in headData.nav" :key="index">{{item.name}}</div>
                </div>
            </div>
            <div class="align">
                <div class="hcSearchBox between">
                    <el-input v-model="input" placeholder="搜索服务" clearable class="searchIpt"></el-input>
                    <img src="../assets/icon/search.png" class="hcSearchBtn" @click="hcSearchBtnTap()">
                </div>
                <div class="headTopLogin" @click="getLogin" v-if="userDetail == '0'">登录/注册</div>
                <div class="headTopLogin" @click="removeLogin" v-else>退出</div>
            </div>
        </div>
        <el-image :src="require('@/assets/image/loginBg.jpg')" fit="cover" style="width:0;height:0;position: fixed;left: -100px;top: -100px;"></el-image>
    </div>
</template>
<script>
    export default {
        data(){
            return{
                userDetail: 0,
                headData: {},
                value: '',
                input: '',
                active: 0,
                isMy: false
            }
        },
        watch:{
            $route(to,from){
                if(from.path == '/login/login'){
                    this.userDetail = JSON.parse(localStorage.getItem("userInfo")) || 0
                }
                this.isMy = to.path == '/my/my' ? true : false
                console.log(to.path)
                console.log(this.isMy)
            }
        },
        created() {
            window.addEventListener('keydown', this.searchKey, true)//开启监听键盘按下事件
        },
        mounted(){
            this.userDetail = JSON.parse(localStorage.getItem("userInfo")) || 0
            this.getAppHead()
        },
        methods: {
            // 网站头数据
            getAppHead(){
                this.request.get("index/index/top",{
                    params:{
                       
                    }
                })
                .then(res=>{
                    this.headData = res.data
                })
            },
            // logo点击
            logoTap(){
                this.$router.push({ path:'/' })
            },
            selChange(e){
                console.log(e)
            },
            // 跳转我的订单
            getMy(){
                // this.$router.push({ path:'/my/my', query:{type: 'order'} })
            },
            // 跳转登录
            getLogin(){
                this.$router.push({ path:'/login/login' })
            },
            // 退出登录
            removeLogin(){
                localStorage.removeItem('userInfo')
                this.$router.go(0)
            },
            // tab切换
            headTabTap(i,e){
                this.active = i
                this.$router.push({ path:e })
            },
            // 自定义跳转
            headNavTap(e){
                if(this.userDetail == '0'){
                    this.getLogin()
                }else{
                    this.$router.push({ path:e })
                }
            },
            searchKey(e){
                if(e.keyCode === 13 && this.$route.path != '/login/login' && this.$route.path != '/my/my'){
                    this.hcSearchBtnTap()
                }
            },
            // 搜索
            hcSearchBtnTap(){
                console.log(this.input)
                if(this.input == ''){
                    this.$message({
                        message: '请输入您要搜索的内容',
                        type: 'warning'
                    });
                }else{
                    // if(this.$route.path == '/search/search' && this.$route.query.key != this.input){
                    //     this.$router.replace({query:{key:this.input} })
                    // }
                    // if(this.$route.path != '/search/search'){
                    //     this.$router.push({ path:'/search/search', query:{key:this.input} })
                    // }
                }
            }
        }
    }
</script>
<style lang="less" scoped>
    .headContent{
        width: 100vw;
        background: #fff;
        .headTopBox{
            width: 1232px;
            height: 80px;
            display: flex;
            justify-content: space-between;
            margin: 0 auto;
            .logoBox{
                height: 56px;
                cursor: pointer;
                .logo{
                    width: 56px;
                    height: 56px;
                }
                .appName{ 
                    font: bold 22px/56px "Microsoft YaHei";
                    padding-left: 8px;
                }                  
            }
            .headTopNavList{
                height: 80rpx;
                margin-left: 60px;
                .headTopNav{
                    padding: 0 27px;
                    font: 16px/80px "Microsoft YaHei";
                    color: #161825;
                    cursor: pointer;
                    &:hover{ 
                        color: #0F59FE;
                    }
                }
                .headTopNavOn{
                    color: #0F59FE;
                }
            }
            .hcSearchBox{
                width: 256px;
                height: 36px;
                padding: 0 12px 0 16px;
                background: #F2F3F5;
                border-radius: 18px;
                .searchIpt{
                    width: 214px;
                    height: 36px;
                    font: 16px/36px "Microsoft YaHei";
                    color: #6D6D6D;
                    /deep/ .el-input__inner {
                        height: 36px;
                        border: none;
                        background: #F2F3F5;
                        padding: 0;
                    }
                }
                .hcSearchBtn{
                    width: 32px;
                    height: 32px;
                    cursor: pointer;
                }
            }
            .headTopLogin{
                width: 94px;
                height: 34px;
                background: #0F59FE;
                border-radius: 2px;
                font: 14px/34px "Microsoft YaHei";
                color: #fff;
                text-align: center;
                margin-left: 32px;
                cursor: pointer;
            }
        }
    }
</style>